import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';

import React from 'react';

import style from './feature-availability-display.module.css';

/**
 * @param {object} props
 * @param {boolean} props.isFeatureAvailable
 * @returns {React.JSX.Element}
 */
export const FeatureAvailabilityDisplay = ({ isFeatureAvailable }) => {
  return isFeatureAvailable ? (
    <FontAwesomeIcon className={style['checkmark-icon']} icon={faCheck} />
  ) : (
    <FontAwesomeIcon className={style['dash-icon']} icon={faMinus} />
  );
};
